<template>
  <div>
    <el-form
      ref="form"
      :model="formData"
      :rules="rules"
      size="mini"
      :disabled="disabled"
    >
      <el-row :gutter="10">
        <el-col :span="4">
          <el-form-item :label="$l('form_label_applyDate') || '申请日期'" prop="applyDate">
            <el-date-picker
              v-model="formData.applyDate"
              value-format="yyyy-MM-dd"
              format="yyyy/MM/dd"
              type="date"
              :placeholder="$l('form_label_pl_applyDate') || '请选择申请日期'"
              style="width: 100%"
              :disabled="disabled"
            />
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item :label="$l('form_label_applyUserCode') || '申请人'" prop="applyUserCode">
            <dict-select
              v-model="formData.applyUserCode"
              :selectedLabel.sync="formData.applyUserName"
              url="/master/common/dict/baseUserSelect"
              filterable
              clearable
              :placeholder="$l('form_label_pl_applyUserCode') || '请选择申请人'"
              style="width:100%"
              :disabled="disabled"
              @change="applyUserChange"
              size="mini"
            />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item :label="$l('form_label_applyDeptCode') || '申请部门'" prop="applyDeptCode">
            <el-input
              v-model="formData.applyDeptName"
              :disabled="disabled"
              :placeholder="$l('form_label_pl_applyDeptCode') || '请选择申请人后自动带出'"
            />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item :label="$l('form_label_companyCode') || '所属公司'" prop="companyCode">
            <el-input
              v-model="formData.companyName"
              :disabled="disabled"
              :placeholder="$l('form_label_pl_companyCode') || '请选择申请人后自动带出'"
            />
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="10">
        <el-col :span="12">
          <el-form-item :label="$l('form_label_customerCode') || '客户'" prop="customerCode">
            <dict-select
              v-model="formData.customerCode"
              :selectedLabel.sync="formData.customerName"
              url="/master/common/dict/customerSelect"
              filterable
              clearable
              :placeholder="$l('form_label_pl_customerCode') || '请选择客户'"
              style="width:100%"
              :disabled="disabled"
              size="mini"
            />
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item :label="$l('form_label_deliveryDeadline') || '交货期限'" prop="deliveryDeadline">
            <el-date-picker
              v-model="formData.deliveryDeadline"
              value-format="yyyy-MM-dd"
              format="yyyy/MM/dd"
              type="date"
              :placeholder="$l('form_label_pl_deliveryDeadline') || '请选择交货期限'"
              style="width: 100%"
              :disabled="disabled"
            />
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item :label="$l('form_label_urgencyLevel') || '紧急程度'" prop="urgencyLevel">
            <br/>
            <dict-radio-group
              class="urgency-radio"
              size="mini"
              v-model="formData.urgencyLevel"
              :checkValue.sync="formData.urgencyLevel"
              :button="true"
              url="/sys/common/dict/system"
              :body="{ dictType: 'DF_INSPECTION_APPLY_URGENCY_LEVEL' }"
              :disabled="disabled"
              style="width:100%"
            >
            </dict-radio-group>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item :label="$l('form_label_inspectionResult') || '验货结果'">
            <dict-select
              size="mini"
              v-model="formData.inspectionResult"
              url="/sys/common/dict/system"
              :body="{ dictType: 'DF_INSPECTION_APPLY_RESULT' }"
              filterable
              clearable
              :placeholder="$l('form_label_pl_inspectionResult') || '请选择验货结果'"
              style="width:100%"
              :disabled="disabled"
            />
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="10">
        <el-col :span="12">
          <el-form-item :label="$l('form_label_orderNos') || '订单号'" prop="orderNos">
            <el-input
              type="textarea"
              :rows="3"
              v-model="formData.orderNos"
              :maxlength="2000"
              :disabled="disabled"
              :placeholder="$l('form_label_pl_orderNos') || '选择订单选择验货产品明细后，自动生成'"
              readonly
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item :label="$l('form_label_applyReason') || '申请事由'" prop="applyReason">
            <el-input
              type="textarea"
              :rows="3"
              v-model="formData.applyReason"
              :maxlength="500"
              :disabled="disabled"
              :placeholder="$l('form_label_pl_applyReason') || '请输入申请事由'"
            />
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="10">
        <el-col :span="4">
          <el-form-item :label="$l('form_label_inspectionStartDate') || '验货开始日期'" prop="inspectionStartDate">
            <el-date-picker
              v-model="formData.inspectionStartDate"
              value-format="yyyy-MM-dd"
              format="yyyy/MM/dd"
              type="date"
              :placeholder="$l('form_label_pl_inspectionStartDate') || '请选择验货开始日期'"
              style="width: 100%"
              :disabled="disabled"
            />
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item :label="$l('form_label_inspectionStartTime_v') || '验货开始时间'" prop="inspectionStartTime">
            <el-time-picker
              :placeholder="$l('form_label_pl_inspectionStartTime') || '请选择验货开始时间'"
              v-model="formData.inspectionStartTime"
              format="HH:mm"
              value-format="HH:mm:ss"
              style="width: 100%"
            >
            </el-time-picker>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item :label="$l('form_label_inspectionEndDate') || '验货结束日期'" prop="inspectionEndDate">
            <el-date-picker
              v-model="formData.inspectionEndDate"
              value-format="yyyy-MM-dd"
              format="yyyy/MM/dd"
              type="date"
              :placeholder="$l('form_label_pl_inspectionEndDate') || '请选择验货结束日期'"
              style="width: 100%"
              :disabled="disabled"
            />
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item :label="$l('form_label_inspectionEndTime') || '验货结束时间'" prop="inspectionEndTime">
            <el-time-picker
              :placeholder="$l('form_label_pl_inspectionEndTime') || '请选择验货结束时间'"
              v-model="formData.inspectionEndTime"
              format="HH:mm"
              value-format="HH:mm:ss"
              style="width: 100%"
            >
            </el-time-picker>
          </el-form-item>
        </el-col>

        <el-col :span="8">
          <el-form-item :label="$l('form_label_inspectorName') || '申请QC'">
            <el-input
              clearable
              v-model="formData.inspectorName"
              readonly
              size="mini"
              style="width:100%"
              :placeholder="$l('form_label_pl_inspectorName') || '请选择申请QC'"
              :disabled="disabled"
            >
              <el-button
                slot="append"
                icon="el-icon-finished"
                @click="openOrderPackingDialog"
                size="medium"
                :disabled="disabled"
              ></el-button>
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="4">
          <el-form-item :label="$l('form_label_isHxInspection') || '是否合祥验货'" prop="isHxInspection">
            <el-radio-group
              v-model="formData.isHxInspection"
              :disabled="disabled"
            >
              <el-radio label="Y">{{ $l('form_label_isHxInspection_yes') || '合祥验货' }}</el-radio>
              <el-radio label="N">{{ $l('form_label_isHxInspection_no') || '外厂验货' }}</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item :label="$l('form_label_inspectionFactory') || '验货工厂'" prop="inspectionFactory">
            <dict-select
              size="mini"
              clearable
              filterable
              v-model="formData.inspectionFactory"
              :selectedLabel.sync="formData.inspectionFactoryName"
              :body="{}"
              url="/master/common/dict/scmPartners"
              :placeholder="$l('form_label_pl_inspectionFactory') || '请选择验货工厂'"
              :disabled="disabled"
              @change="getScmData"
            ></dict-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item :label="$l('form_label_hxInspectionRoom') || '申请合祥验货间'">
            <el-input
              clearable
              v-model="formData.hxInspectionRoomText"
              readonly
              size="mini"
              style="width:100%"
              :placeholder="$l('form_label_pl_hxInspectionRoom') || '请点击按钮选择验货间'"
              :disabled="disabled"
              @clear="onClearHxInspectionRoom"
            >
              <el-button
                slot="append"
                icon="el-icon-finished"
                size="medium"
                :disabled="disabled"
                @click="openChooseWorkshopDialog"
              />
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="4">
          <el-form-item :label="$l('form_label_inspectionProvinceCode') || '验货省份'" prop="inspectionProvinceCode">
            <el-select
              size="mini"
              v-model="formData.inspectionProvinceCode"
              :placeholder="$l('form_label_pl_inspectionProvinceCode') || '请选择验货省份'"
              style="width: 100%"
              @change="loadInspectionCityOptions"
              filterable
              clearable
              :disabled="disabled"
            >
              <el-option
                v-for="item in inspectionProvinceOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item :label="$l('form_label_inspectionCityCode') || '验货城市'" prop="inspectionCityCode">
            <el-select
              size="mini"
              v-model="formData.inspectionCityCode"
              :placeholder="$l('form_label_pl_inspectionCityCode') || '请选择验货城市'"
              style="width: 100%"
              @change="loadInspectionDistrictOptions"
              filterable
              clearable
              :disabled="disabled"
            >
              <el-option
                v-for="item in inspectionCityOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item :label="$l('form_label_inspectionDistrictCode') || '验货区县'" prop="inspectionDistrictCode">
            <el-select
              size="mini"
              v-model="formData.inspectionDistrictCode"
              :placeholder="$l('form_label_pl_inspectionDistrictCode') || '请选择验货区县'"
              style="width: 100%"
              @change="syncInspectionDistrictName"
              filterable
              clearable
              :disabled="disabled"
            >
              <el-option
                v-for="item in inspectionDistrictOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item :label="$l('form_label_inspectionAddress') || '验货详细地址'" prop="inspectionAddress">
            <el-input
              v-model="formData.inspectionAddress"
              :disabled="disabled"
              maxlength="300"
              :placeholder="$l('form_label_pl_inspectionAddress') || '请输入验货详细地址'"
            />
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="10">
        <el-col :span="24">
          <el-form-item :label="$l('form_label_remark') || '备注说明'">
            <el-input
              type="textarea"
              :rows="4"
              v-model="formData.remark"
              :maxlength="500"
              :disabled="disabled"
              :placeholder="$l('form_label_pl_remark') || '请输入备注说明'"
            />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <ChooseUserDialog
      :visible.sync="chooseInspectorVisible"
      width="1000px"
      confirmOnClose
      :multiple="false"
      @confirm="chooseInspectorConfirm"
    />
    <ChooseWorkshopDialog
      :visible.sync="chooseWorkshopVisible"
      @confirm="chooseWorkshopConfirm"
    />
  </div>
</template>

<script>
import dayjs from '@/libs/util.date'
import validate from '@/libs/util.validate'
import EditLoading from '@/mixins/edit-loading'
import { request } from '@/api/service'
import { mapState } from 'vuex'
import DictRadioGroup from '@/views/factory/components/dict-radio-group'
import ChooseUserDialog from '../choose-user/choose-user-dialog'
import ChooseWorkshopDialog from '../choose-workshop'

const initFormData = () => ({
  inspectionApplyCode: '',
  applyNo: '',
  applyTitle: '',
  applyDate: dayjs(new Date()).format('YYYY-MM-DD'),
  applyUserCode: '',
  applyUserName: '',
  applyDeptCode: '',
  companyCode: '',
  customerCode: '',
  customerName: '',
  deliveryDeadline: '',
  urgencyLevel: '1',
  inspectionResult: '',
  orderNos: '',
  applyReason: '',
  inspectionStartDate: '',
  inspectionStartTime: '',
  inspectionEndDate: '',
  inspectionEndTime: '',
  inspectorCode: '',
  inspectorName: '',
  isHxInspection: 'Y',
  inspectionFactory: '',
  hxInspectionRoom: '',
  hxInspectionRoomText: '',
  inspectionProvinceCode: '',
  inspectionProvinceName: '',
  inspectionCityCode: '',
  inspectionCityName: '',
  inspectionDistrictCode: '',
  inspectionDistrictName: '',
  inspectionAddress: '',
  remark: '',
  applyStatus: '1',
  productDetailList: [],
  productImageList: [],
  docList: [],
})

export default {
  mixins: [EditLoading],
  components: { DictRadioGroup, ChooseUserDialog, ChooseWorkshopDialog },
  props: {
    disabled: { type: Boolean, default: true },
    auditDisabled: { type: Boolean, default: true },
    inspectionApplyCode: { type: String, default: '' },
  },
  data() {
    return {
      chooseInspectorVisible: false,
      chooseWorkshopVisible: false,
      formData: initFormData(),
      inspectionProvinceOptions: [],
      inspectionCityOptions: [],
      inspectionDistrictOptions: [],
      rules: {
        applyDate: [
          { required: true, message: this.$l('form_label_pl_applyDate') || '请选择申请日期', trigger: 'change' },
        ],
        applyUserCode: [
          { required: true, message: this.$l('form_label_pl_applyUserCode') || '请选择申请人', trigger: 'change' },
        ],
        applyDeptCode: [
          { required: true, message: this.$l('form_label_pl_applyDeptCodeInput') || '请输入申请部门', trigger: 'blur' },
        ],
        deliveryDeadline: [
          { required: true, message: this.$l('form_label_pl_deliveryDeadline') || '请选择交货期限', trigger: 'change' },
        ],
        companyCode: [
          { required: true, message: this.$l('form_label_pl_companyCodeInput') || '请输入所属公司', trigger: 'blur' },
        ],
        customerCode: [
          { required: true, message: this.$l('form_label_pl_customerCode') || '请选择客户', trigger: 'change' },
        ],
        urgencyLevel: [
          { required: true, message: this.$l('form_label_pl_urgencyLevel') || '请选择紧急程度', trigger: 'change' },
        ],
        applyReason: [
          { required: true, message: this.$l('form_label_pl_applyReason') || '请输入申请事由', trigger: 'blur' },
        ],
        inspectionStartDate: [
          { required: true, message: this.$l('form_label_pl_inspectionStartDate') || '请选择验货开始日期', trigger: 'change' },
        ],
        inspectionStartTime: [
          { required: true, message: this.$l('form_label_pl_inspectionStartTime') || '请选择验货开始时间', trigger: 'change' },
        ],
        inspectionEndDate: [
          { required: true, message: this.$l('form_label_pl_inspectionEndDate') || '请选择验货结束日期', trigger: 'change' },
        ],
        inspectionEndTime: [
          { required: true, message: this.$l('form_label_pl_inspectionEndTime') || '请选择验货结束时间', trigger: 'change' },
        ],
        isHxInspection: [
          { required: true, message: this.$l('form_label_pl_isHxInspection') || '请选择是否合祥验货', trigger: 'change' },
        ],
        inspectionFactory: [
          { required: true, message: this.$l('form_label_pl_inspectionFactoryInput') || '请输入验货工厂', trigger: 'change' },
        ],
        inspectionProvinceCode: [
          { required: true, message: this.$l('form_label_pl_inspectionProvinceCode') || '请选择验货省份', trigger: 'change' },
        ],
        inspectionCityCode: [
          { required: true, message: this.$l('form_label_pl_inspectionCityCode') || '请选择验货城市', trigger: 'change' },
        ],
        inspectionDistrictCode: [
          { required: true, message: this.$l('form_label_pl_inspectionDistrictCode') || '请选择验货区县', trigger: 'change' },
        ],
        inspectionAddress: [
          {
            required: true,
            message: this.$l('form_label_pl_inspectionAddress') || '请输入验货详细地址',
            trigger: ['change', 'blur'],
          },
        ],
      },
    }
  },
  computed: { ...mapState('admin/user', { userInfo: 'info' }) },
  watch: {
    userInfo: {
      immediate: true,
      handler() {
        if (this.inspectionApplyCode || !this.userInfo) return
        const { userCode, userName, userNameEn } = this.userInfo
        this.formData.applyUserCode = userCode || ''
        this.formData.applyUserName = [userNameEn, userName]
          .filter(Boolean)
          .join('-')
        if (userCode) {
          this.applyUserChange(userCode)
        }
      },
    },
  },
  mounted() {
    this.loadInspectionProvinceOptions()
    this.getData()
  },
  methods: {
    updateInspectionName(options, codeKey, nameKey) {
      const selected = options.find(
        (item) => item.value === this.formData[codeKey],
      )
      this.formData[nameKey] = selected ? selected.label : ''
    },
    async getRegionOptions(id = '') {
      return request({
        url: '/sys/region/select',
        method: 'GET',
        params: id ? { id } : {},
      })
        .then((res) => res?.body?.data || [])
        .catch(() => [])
    },
    async loadInspectionProvinceOptions() {
      this.inspectionProvinceOptions = await this.getRegionOptions()
      this.updateInspectionName(
        this.inspectionProvinceOptions,
        'inspectionProvinceCode',
        'inspectionProvinceName',
      )
      await this.loadInspectionCityOptions(false)
    },
    async loadInspectionCityOptions(reset = true) {
      if (typeof reset !== 'boolean') reset = true
      this.updateInspectionName(
        this.inspectionProvinceOptions,
        'inspectionProvinceCode',
        'inspectionProvinceName',
      )
      if (reset) {
        this.formData.inspectionCityCode = ''
        this.formData.inspectionCityName = ''
        this.formData.inspectionDistrictCode = ''
        this.formData.inspectionDistrictName = ''
      }
      if (!this.formData.inspectionProvinceCode) {
        this.inspectionCityOptions = []
        this.inspectionDistrictOptions = []
        return
      }
      this.inspectionCityOptions = await this.getRegionOptions(
        this.formData.inspectionProvinceCode,
      )
      this.updateInspectionName(
        this.inspectionCityOptions,
        'inspectionCityCode',
        'inspectionCityName',
      )
      if (!reset) {
        await this.loadInspectionDistrictOptions(false)
      }
    },
    async loadInspectionDistrictOptions(reset = true) {
      if (typeof reset !== 'boolean') reset = true
      this.updateInspectionName(
        this.inspectionCityOptions,
        'inspectionCityCode',
        'inspectionCityName',
      )
      if (reset) {
        this.formData.inspectionDistrictCode = ''
        this.formData.inspectionDistrictName = ''
      }
      if (!this.formData.inspectionCityCode) {
        this.inspectionDistrictOptions = []
        return
      }
      this.inspectionDistrictOptions = await this.getRegionOptions(
        this.formData.inspectionCityCode,
      )
      if (!reset) {
        this.syncInspectionDistrictName()
      }
    },
    syncInspectionDistrictName() {
      this.updateInspectionName(
        this.inspectionDistrictOptions,
        'inspectionDistrictCode',
        'inspectionDistrictName',
      )
    },
    openOrderPackingDialog() {
      if (this.disabled) return
      this.chooseInspectorVisible = true
    },
    chooseInspectorConfirm(data) {
      const row = Array.isArray(data) ? data[0] : data
      if (!row) return
      const { userCode = '', userName = '', userNameEn = '' } = row
      this.formData.inspectorCode = userCode

      this.formData.inspectorName = [userNameEn, userName]
        .filter(Boolean)
        .join('-')
    },
    openChooseWorkshopDialog() {
      if (this.disabled) return
      this.chooseWorkshopVisible = true
    },
    chooseWorkshopConfirm(row) {
      if (!row) return
      this.formData.hxInspectionRoom = row.inspectionWorkshopCode || ''
      this.formData.hxInspectionRoomText = row.workshopName || ''
    },
    onClearHxInspectionRoom() {
      this.formData.hxInspectionRoom = ''
      this.formData.hxInspectionRoomText = ''
    },

    async getData() {
      if (!this.inspectionApplyCode) return
      const data = await this.$api
        .dfInspectionApplyDetailApi({
          inspectionApplyCode: this.inspectionApplyCode,
        })
        .then((res) => res.body || {})
        .catch(() => ({}))

      this.formData = {
        ...initFormData(),
        ...data,
      }
      await this.loadInspectionProvinceOptions()
      this.$emit('loaded', this.formData)
    },
    async setOrderNos() {
      if (!this.inspectionApplyCode) return
      const data = await this.$api
        .dfInspectionApplyDetailApi({
          inspectionApplyCode: this.inspectionApplyCode,
        })
        .then((res) => res.body || {})
        .catch(() => ({}))

      this.formData.orderNos = data.orderNos || ''
    },
    async save() {
      const result = await validate.formValidate([this.$refs.form])
      if (!result) return
      const inspectionStartTime =
        this.formData.inspectionStartDate +
        ' ' +
        this.formData.inspectionStartTime
      const inspectionEndTime =
        this.formData.inspectionEndDate + ' ' + this.formData.inspectionEndTime
      const startTime = dayjs(inspectionStartTime)
      const endTime = dayjs(inspectionEndTime)

      if (!startTime.isValid() || !endTime.isValid()) {
        this.$message.warning(
          this.$l('form_label_pl_inspectionDateTimeInvalid') ||
            '验货开始/结束日期时间格式不正确',
        )
        return
      }

      if (!startTime.isBefore(endTime)) {
        this.$message.warning(
          this.$l('form_label_pl_inspectionStartBeforeEnd') ||
            '验货开始日期+时间必须小于验货结束日期+时间',
        )
        return
      }

      if (this.loadingOpen()) return

      const res = await this.$api
        .dfInspectionApplySaveApi({
          ...this.formData,
          inspectionStartTime,
          inspectionEndTime,
        })
        .catch(() => null)
      this.loadingClose()
      if (!res) return
      const { status, body = {} } = res
      if (status !== 200) {
        this.$message.error(this.$l('INDEX.tips_save_no') || '保存失败！')
        return
      }
      this.$message({
        showClose: true,
        message: this.$l('INDEX.tips_save_ok') || '保存成功！',
        type: 'success',
      })

      if (this.inspectionApplyCode) return this.getData()

      this.$router.replace({
        name: 'inspection-apply-detail',
        params: { code: body.inspectionApplyCode, pageType: 'edit' },
        query: { applyNo: body.applyNo },
      })
    },
    async applyUserChange(e) {
      this.formData.applyDeptCode = ''
      this.formData.applyDeptName = ''
      this.formData.companyCode = ''
      this.formData.companyName = ''

      const data = await this.$api
        .SYS_USER_DETAIL({
          userCode: e,
        })
        .then((res) => res.body || {})
        .catch(() => ({}))
      if (!data) return
      this.formData = {
        ...this.formData,
        applyDeptCode: data.depCode || '',
        applyDeptName: data.depName || '',
        companyCode: data.orgCode || '',
        companyName: data.orgName || '',
      }
    },
    async getScmData(scmCode) {
      if (!scmCode) {
        this.formData = {
          ...this.formData,
          hxInspectionRoom: '',
          hxInspectionRoomText: '',
          inspectionProvinceCode: '',
          inspectionProvinceName: '',
          inspectionCityCode: '',
          inspectionCityName: '',
          inspectionDistrictCode: '',
          inspectionDistrictName: '',
          inspectionAddress: '',
        }
        this.inspectionCityOptions = []
        this.inspectionDistrictOptions = []
        return {}
      }
      const res = await request({
        url: '/digitalCenter/scmInfo/detail',
        method: 'post',
        data: { scmCode },
      }).catch(() => null)
      const { body = {} } = res
      if (!body) return
      this.formData = {
        ...this.formData,
        inspectionProvinceCode: body.provinceCode || '',
        inspectionProvinceName: body.provinceName || '',
        inspectionCityCode: body.cityCode || '',
        inspectionCityName: body.cityName || '',
        inspectionDistrictCode: body.districtCode || '',
        inspectionDistrictName: body.districtName || '',
        inspectionAddress: body.scmAddress || '',
      }
      await this.loadInspectionCityOptions(false)
    },
  },
}
</script>
<style lang="scss" scoped>
/* 不抖动 */
::v-deep .urgency-radio .el-radio-button__inner {
  transition: none !important;
}

/* 选中通用 */
::v-deep .urgency-radio .el-radio-button__orig-radio:checked + .el-radio-button__inner {
  box-shadow: none !important;
  position: relative;
  border-color: var(--u-bd) !important;
  background: var(--u-bg);
  color: var(--u-fg);
}

/* 修复选中项左侧灰线（统一写一次，颜色走变量） */
::v-deep .urgency-radio .el-radio-button__orig-radio:checked + .el-radio-button__inner::before {
  content: '';
  position: absolute;
  left: -1px;
  top: -1px;
  bottom: -1px;
  width: 1px;
  background: var(--u-bd);
}

/* 仅定义三种值的颜色变量 */
::v-deep .urgency-radio .el-radio-button__orig-radio[value='1']:checked + .el-radio-button__inner {
  --u-bg: #eef5ff;
  --u-bd: #91baff;
  --u-fg: #2f6bff;
}
::v-deep .urgency-radio .el-radio-button__orig-radio[value='2']:checked + .el-radio-button__inner {
  --u-bg: #fff7e8;
  --u-bd: #ffc069;
  --u-fg: #d46b08;
}
::v-deep .urgency-radio .el-radio-button__orig-radio[value='3']:checked + .el-radio-button__inner {
  --u-bg: #fff1f0;
  --u-bd: #ff7875;
  --u-fg: #cf1322;
}


</style>
